"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
require("typeface-poppins");
const ColorVariables = {
    primary: '#B23356',
    secondary: 'transparent'
};
const ButtonVariables = {
    root: {
        fontSize: '12px',
        fontWeight: 'bold',
        borderRadius: '2px',
        fontFamily: 'Poppins',
        lineHeight: '15px',
        height: '37px',
        fontStyle: 'normal'
    }
};
exports.LightTheme = styles_1.createMuiTheme({
    palette: {
        primary: {
            main: '#B23356'
        }
    },
    overrides: {
        MuiButton: {
            root: Object.assign({}, ButtonVariables.root),
            containedPrimary: {
                backgroundcolor: ColorVariables.primary,
                color: '#FFFFFF'
                // "&:hover": {
                //   backgroundColor: ColorVariables.primary
                // }
            },
            outlinedPrimary: {
                color: ColorVariables.primary,
                border: `3px solid ${ColorVariables.primary}`,
                '&:hover': {
                    backgroundColor: '#b233560d',
                    border: `3px solid ${ColorVariables.primary}`
                }
            }
        },
        MuiInputBase: {
            root: {
                fontFamily: 'Poppins',
                fontSize: 14,
                padding: 5,
                paddingLeft: 8,
                marginLeft: -1,
                border: '1px solid #DBDBDB',
                borderRadius: 2
            }
        },
        MuiTypography: {
            h1: {
                fontSize: 40,
                fontFamily: 'Poppins',
                fontWeight: 600
            },
            h2: {
                fontSize: 28,
                fontFamily: 'Poppins',
                fontWeight: 600
            },
            h3: {
                fontSize: 22,
                fontFamily: 'Poppins'
            },
            body1: {
                fontSize: 16,
                fontFamily: 'Poppins'
            },
            subtitle1: {
                fontSize: 14,
                fontFamily: 'Poppins',
                color: '#414141'
            }
        },
        MuiTableCell: {
            root: {
                fontFamily: 'Montserrat',
                textAlign: 'center',
                padding: 20
            },
            head: {
                // color: "#FFFFFF",
                fontFamily: 'Montserrat',
                textTransform: 'uppercase',
                fontSize: 12,
                fontWeight: 'bold',
                border: 'none',
                '&:hover': {
                    color: 'white'
                }
            },
            body: {
                border: 'none',
                fontSize: 12
            }
        },
        MuiTableSortLabel: {
            root: {
                color: 'white !important',
                '&:hover': {
                    color: 'white !important'
                }
            },
            active: {
                color: 'white !important',
                '&:hover': {
                    color: 'white !important'
                }
            },
            icon: {
                color: 'white !important',
                '&:hover': {
                    color: 'white !important'
                }
            }
        },
        MuiTableRow: {
            root: {
                fontFamily: 'Poppins',
                // "&:hover": {
                //   backgroundColor: "#E0E0E0"
                // },
                // backgroundColor: "#F7F7F7",
                '&:nth-of-type(odd)': {
                    backgroundColor: '#FAFAFA'
                    // "&:hover": {
                    //   backgroundColor: "#E0E0E0"
                    // }
                }
            }
        },
        MuiTable: {
            root: {
                fontFamily: 'Poppins'
            }
        }
    }
});
exports.default = exports.LightTheme;
//# sourceMappingURL=light.js.map